import React from 'react';
import { CalendarDays, ShieldCheck, Wrench, Users } from 'lucide-react';
export function TrustStrip() {
  const features = [{
    icon: <CalendarDays className="w-6 h-6 text-blue-600" data-id="element-223" />,
    title: 'Weekly Route Service',
    desc: 'Consistent, reliable maintenance'
  }, {
    icon: <Users className="w-6 h-6 text-blue-600" data-id="element-224" />,
    title: 'Local & Owner-Operated',
    desc: 'Serving Gilbert & the East Valley'
  }, {
    icon: <Wrench className="w-6 h-6 text-blue-600" data-id="element-225" />,
    title: 'Repairs Done Right',
    desc: 'Expert troubleshooting'
  }, {
    icon: <ShieldCheck className="w-6 h-6 text-blue-600" data-id="element-226" />,
    title: 'Reliable Techs',
    desc: 'Trained, professional staff'
  }];
  return <div className="bg-white border-b border-slate-100 py-8 relative z-20 -mt-8 mx-4 sm:mx-6 lg:mx-8 rounded-2xl shadow-xl shadow-slate-200/50 max-w-7xl xl:mx-auto" data-id="element-227">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 px-8" data-id="element-228">
        {features.map((feature, idx) => <div key={idx} className="flex items-start gap-4" data-id="element-229">
            <div className="bg-blue-50 p-3 rounded-xl shrink-0" data-id="element-230">
              {feature.icon}
            </div>
            <div data-id="element-231">
              <h3 className="font-bold text-slate-900 mb-1" data-id="element-232">{feature.title}</h3>
              <p className="text-sm text-slate-500" data-id="element-233">{feature.desc}</p>
            </div>
          </div>)}
      </div>
    </div>;
}